import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from 'payments-checkout-lib/constants/Sizes';
import { useSubtotals } from '../../context/SubtotalsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// used for one-time, order-level discounts (not discount codes)
export function OrderLevelDiscount({
  currencyCode,
  orderDiscount
}) {
  // these values are dynamic because open-amount line items (price is editable by the buyer)
  // and percentage based discounts mean that the discount value in dollars can change during checkout
  const {
    oneTimeDiscountAmount // calculated discount amount in dollars
  } = useSubtotals();
  const discountAmount = /*#__PURE__*/_jsx("div", {
    "data-test-id": "checkout-order-level-discount--amount",
    children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      value: oneTimeDiscountAmount * -1,
      currencyCode: currencyCode
    })
  });
  const {
    label,
    value,
    valueType
  } = orderDiscount;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: LEFT_GRID_SIZE,
      children: /*#__PURE__*/_jsx(Text, {
        as: "h6",
        "data-test-id": "checkout-order-level-discount--label",
        textAlign: "start",
        children: label
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: RIGHT_GRID_SIZE,
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "checkout-order-level-discount--total",
        children: valueType === 'PERCENT' ? /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          alignItems: "end",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h6",
            paddingBlockEnd: "200",
            children: discountAmount
          }), /*#__PURE__*/_jsx(Text, {
            color: "fill-positive-default",
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "payments.afterDiscount",
              options: {
                discountValue: /*#__PURE__*/_jsx(FormattedPercentage, {
                  "data-test-id": "checkout-order-level-discount--percent",
                  value: value,
                  precision: 5
                })
              }
            })
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          textAlign: "end",
          as: "h6",
          paddingBlockEnd: "100",
          children: discountAmount
        })
      })
    })]
  });
}